import { SimulationProvider } from "./context/SimulationContext";
import AppRoutes from "./routes";
import CustomTheme from "./Theme/Theme";

function App() {
  return (
    <>
      <SimulationProvider>
        <CustomTheme>
          <AppRoutes />
        </CustomTheme>
      </SimulationProvider>
    </>
  );
}

export default App;
